document.addEventListener("DOMContentLoaded", function () {
  var $swiperSelector = $('.swiper-container');

  $swiperSelector.each(function (index) {
    var $this = $(this);
    var uniqueClass = 'swiper-slider-' + index;
    $this.addClass(uniqueClass);

    var enableMobile = $this.data('enable-mobile') === true || $this.data('enable-mobile') === 'true';
    var enableMobileOnly = $this.data('enable-mobile-only') === true || $this.data('enable-mobile-only') === 'true';
    var enableDesktopOnly = $this.data('enable-desktop-only') === true || $this.data('enable-desktop-only') === 'true';
    var slidesDesktop = parseFloat($this.data('slides-desktop')) || 4;
    var slidesTablet = parseFloat($this.data('slides-tablet')) || 3;
    var slidesMobile = parseFloat($this.data('slides-mobile')) || 1.5;
    var spaceBetween = parseFloat($this.data('space-between')) || 20;
    var isMobile = window.innerWidth <= 768;
    var disableBothClass = $this.attr('data-soring-between');
    //console.log("disableBothClass",disableBothClass)

    // 🧠 Mobile-only or disabled logic
    if (enableMobileOnly) {
      if (!isMobile) {
        $this.find('.swiper-wrapper').addClass('no-swiper');
        $this.find('.swiper-button-prev, .swiper-button-next, .swiper-scrollbar').hide();
        return;
      }
    }else if(enableDesktopOnly){
      if (isMobile) {
        $this.find('.swiper-wrapper').addClass('no-swiper');
        $this.find('.swiper-button-prev, .swiper-button-next, .swiper-scrollbar').hide();
        return;
      }
    }else if (!enableMobileOnly && !enableMobile && !enableDesktopOnly) {
      if (disableBothClass) {       
          $this.find('.swiper-wrapper').addClass('no-swiper' + disableBothClass);
          $this.find('.swiper-slide').addClass('grid__item');
      } else {
          $this.find('.swiper-wrapper').addClass('no-swiper ss');
      }    
        $this.find('.swiper-button-prev, .swiper-button-next, .swiper-scrollbar').hide();
        return;
    }else if (isMobile && !enableMobile) {
      $this.find('.swiper-wrapper').addClass('no-swiper');
      return;
    }

    // ✅ Initialize Swiper
    new Swiper('.' + uniqueClass, {
      direction: 'horizontal',
      loop: false,
      freeMode: true,
      slidesPerView: slidesDesktop,
      spaceBetween: spaceBetween,
      speed: 800,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: $this.find('.swiper-button-next')[0],
        prevEl: $this.find('.swiper-button-prev')[0],
      },
      scrollbar: {
        el: $this.find('.swiper-scrollbar').get(0),
        draggable: true,
        dragSize: 'auto',
      },
      breakpoints: {
        1200: { slidesPerView: slidesDesktop },
        768: { slidesPerView: slidesTablet },
        0: { slidesPerView: slidesMobile },
      },
      on: {
        init: function () {
          const scrollbarEl = $this.find('.swiper-scrollbar').get(0);
          if (scrollbarEl) scrollbarEl.style.cursor = 'pointer';
        },
      },
    });
  });
});


